/**
 * Platform-specific configuration for OAuth onboarding
 * Used by DynamicPlatformOnboarding and PlatformAuthForm
 */

export const PLATFORM_CONFIG = {
  tiktok: {
    displayName: 'TikTok Ads',
    description: 'Connect your TikTok For Business advertising account to sync campaigns and performance data.',
    requirements: [
      'TikTok For Business account',
      'Ad account access',
      'Admin permissions',
    ],
    capabilities: [
      'Campaign performance reporting',
      'Ad spend and metrics tracking',
      'Creative performance insights',
      'Audience analytics',
    ],
  },
  google: {
    displayName: 'Google Ads',
    description: 'Connect your Google Ads account to sync campaigns, keywords, and performance data.',
    requirements: [
      'Google Ads account',
      'Admin access to Google Ads',
    ],
    capabilities: [
      'Campaign and ad group reporting',
      'Keyword performance tracking',
      'Conversion tracking',
      'Search query insights',
      'Budget and spend analytics',
    ],
  },
  meta: {
    displayName: 'Meta Advertising',
    description: 'Connect your Meta Business account to sync Facebook and Instagram ad campaigns and performance.',
    requirements: [
      'Meta Business account',
      'Ad account access',
      'Admin permissions',
    ],
    capabilities: [
      'Campaign performance reporting',
      'Ad creative insights',
      'Audience targeting analytics',
      'Conversion tracking',
      'Cross-platform (Facebook/Instagram) reporting',
    ],
  },
  microsoft: {
    displayName: 'Microsoft Advertising',
    description: 'Connect your Microsoft Advertising account to sync Bing and Microsoft ad campaigns and performance.',
    requirements: [
      'Microsoft Advertising account',
      'Admin access to Microsoft Ads',
    ],
    capabilities: [
      'Campaign and ad group reporting',
      'Keyword performance tracking',
      'Search advertising analytics',
      'Conversion tracking',
      'Budget and spend insights',
    ],
  },
};

/**
 * Get platform configuration by key
 * @param {string} platform - Platform key (e.g., 'tiktok', 'google')
 * @returns {object|null} Platform config or null if not found
 */
export const getPlatformConfig = (platform) => {
  if (!platform) return null;
  return PLATFORM_CONFIG[platform.toLowerCase()] || null;
};
